/**
 * UUID shape check (versions 1–5, RFC 4122 variant). Thread and message IDs are
 * uuid4, so this is the client-side check for any pasted or parsed ID.
 *
 * Lives here, not in `src/pages/helpers.js`, so callers can use it without
 * pulling in that module's store and analytics import graph.
 */
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isUUID = (value: string): boolean => UUID_REGEX.test(value);
